<div class="gallery-container">
    <div class="header">
        <div class="title">
            <span>{{'attachments'|translate}}</span>
        </div>
        <div class="close" (click)="handleClose()">
            <span>X</span>
        </div>
    </div>
    <div #preview class="preview">
        <ng-container *ngIf="selectedFile.type === 'image'; else video">
            <ng-container *ngIf="!isPreviewLoading">
                <ng-container *ngIf="screenSize?.width < 1024; else largeScreen">
                    <pinch-zoom class="preview-img" *ngIf="selectedFile.url" [index]="0">
                        <img [src]="[selectedFile.url]" />
                    </pinch-zoom>
                </ng-container>

                <ng-template #largeScreen>
                    <angular-image-viewer class="preview-img" *ngIf="selectedFile.url" [index]="0"
                        [src]="[selectedFile.url]" [config]="config">
                    </angular-image-viewer>
                </ng-template>
            </ng-container>
        </ng-container>
        <ng-template #video>
            <video *ngIf="!isPreviewLoading" width="100%" controls>
                <source [src]="selectedFile.url" type="video/mp4">
            </video>
        </ng-template>
    </div>
    <div class="note">
        <span *ngIf="selectedFile?.notes"><span
                class="bold">{{'tech-app.note'|translate}}:&nbsp;</span>{{selectedFile.notes}}</span>
    </div>
    <div class="gallery">
        <div class="gallery-item" *ngFor="let media of mediaFiles">
            <div class="img-container" [ngClass]="{'img-container-selected': selectedFile.url === media.url}"
                (click)="selectMedia(media)">
                <img *ngIf="media.type === 'image'" class="img" [src]="media.url" />
                <div *ngIf="media.type === 'video'" class="vdo">
                    <video class="video-container">
                        <source [src]="media.url" type="video/mp4">
                    </video>
                    <span class="play-btn-overlay">
                        <img class="overlay-img" src="./assets/img/icon/play-button.svg" />
                    </span>
                </div>
            </div>
            <div *ngIf="isRemovingAllowed && (media.type === 'image' || media.type === 'video')" class="remove-btn"
                (click)="removeMedia(media)">
                <span>{{'tech-app.remove'|translate}}</span>
            </div>
        </div>
    </div>
</div>